/* eslint-disable */

import { navigate } from 'gatsby';
import {
    PageSizes,
    PDFDocument,
    PDFFont,
    PDFPage,
    StandardFonts,
} from 'pdf-lib';
import { KeyboardEvent } from 'react';
import { IChatData, IFormChat } from '../interfaces/chat.interface';
import useBrowserMode from '../shared/hooks/useBrowserMode';

declare global {
    interface Window {
        ga_debug?: { trace: boolean };
        dataLayer?: any[];
    }
}

// @ts-ignore
import logo_cda from '../assets/images/CDA/CentroDeAyudaLogo_1-2.png';

const { window, localStorage } = useBrowserMode();

export const changeFontSize = (action: string, fontSize: any) => {
    if (typeof window !== 'undefined') {
        const item = document.querySelector('html')!;

        switch (action) {
            case '+':
                if (fontSize.get < 120) {
                    item.style.fontSize = `${fontSize.get + 20}%`;
                    fontSize.set(fontSize.get + 20);
                }
                break;
            case '-':
                if (fontSize.get > 80) {
                    item.style.fontSize = `${fontSize.get - 20}%`;
                    fontSize.set(fontSize.get - 20);
                }
                break;
        }
    }
};

export const handleKeyAction = (
    event: KeyboardEvent<HTMLAnchorElement>,
    url: string,
    blank?: boolean
) => {
    if (blank && (event.key === 'Enter' || event.key === ' ')) {
        event.preventDefault();
        window.open(url, '_blank', 'noopener,noreferrer');
    } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        navigate(url);
    }
};

export const sanitizeString = (text: string): string => {
    return text.replace(/[`~!#$%^&*()_|+\-=?;:'",<>\{\}\[\]\\\/]/gi, '');
};

export const scrollToTop = () => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
};

export const showScrollBtn = (scrollBtn: HTMLElement) => {
    scrollBtn.classList.add('fixed-on-internal');

    scrollBtn.style.display =
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
            ? 'block'
            : 'none';
};

export const hasStartSlash = (slug: string) => {
    const reg = new RegExp('^/');
    return slug?.search(reg) === -1 ? `/${slug}` : slug;
};

export const toLocalStoragepageActive = () => {
    if (localStorage?.getItem('Redirection')) {
        const storage: any = localStorage?.getItem('Redirection');
        const data = JSON.parse(storage);
        return data.titleButton === 'CENTRO DE AYUDA'
            ? false
            : localStorage?.setItem(
                  'Redirection',
                  JSON.stringify({
                      titleButton: 'CENTRO DE AYUDA',
                      path: 'ayuda',
                  })
              );
    } else {
        return localStorage.setItem(
            'Redirection',
            JSON.stringify({
                titleButton: 'CENTRO DE AYUDA',
                path: 'ayuda',
            })
        );
    }
};

function removeChars(str: string): string {
    return str.replace(/[^\w\s¿?áéíóúÁÉÍÓÚ:,.-]/g, '');
}

export const generatePDFChat = async (chatDataMD: IChatData[]) => {
    const pdfDoc = await PDFDocument.create();
    let page = pdfDoc.addPage(PageSizes.A4);
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const fontSize = 14;
    const margin = 30;
    const lineSpacing = 10;
    const maxWidth = page.getWidth() - 2 * margin;
    let paddingTop = 700;

    const imageBytes = await fetch(logo_cda).then((res) => res.arrayBuffer());
    const image = await pdfDoc.embedPng(imageBytes);
    const { width, height } = image.scale(1);
    page.drawImage(image, {
        x: 140,
        y: 760,
        width,
        height,
    });

    const drawText = (
        page: PDFPage,
        text: string,
        font: PDFFont,
        fontSize: number,
        x: number,
        y: number,
        maxWidth: number
    ) => {
        let currentY = y;
        let currentLine = '';
        const words = text.split(' ');

        words.forEach((word: string) => {
            const testLine = currentLine ? `${currentLine} ${word}` : word;
            const testWidth = font.widthOfTextAtSize(testLine, fontSize);

            if (testWidth < maxWidth) {
                currentLine = testLine;
            } else {
                page.drawText(currentLine, {
                    x,
                    y: currentY,
                    font,
                    size: fontSize,
                });
                currentY -= fontSize + lineSpacing;

                if (currentY < margin + fontSize) {
                    page = pdfDoc.addPage(PageSizes.A4);
                    currentY = 750;
                }

                currentLine = word;
            }
        });

        if (currentLine) {
            page.drawText(currentLine, {
                x,
                y: currentY,
                font,
                size: fontSize,
            });
        }
    };

    for (const line of chatData) {
        const textToDraw =
            line.from === 'form'
                ? `Comfama: ${removeChars(line.message)}\nNombre: ${
                      userData?.name
                  }\nEmail: ${userData?.email}`
                : `${line.from}: ${removeChars(line.message)}`;

        const textLines = textToDraw.split('\n');
        for (const textLine of textLines) {
            const textHeight = font.heightAtSize(fontSize) + lineSpacing;

            if (paddingTop - textHeight < margin) {
                page = pdfDoc.addPage(PageSizes.A4);
                paddingTop = 750;
            }

            drawText(
                page,
                textLine,
                font,
                fontSize,
                margin,
                paddingTop,
                maxWidth
            );
            paddingTop -=
                (fontSize + lineSpacing) * Math.ceil(textLine.length / 70);
        }
    }
    for (const line of chatDataMD) {
        const textToDraw = `${line.from}: ${removeChars(line.message)}`;

        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Comfama_CDA_CHAT.pdf';
        a.click();
        URL.revokeObjectURL(url);
    }
};

export const convertMarkdownToHTML = (markdown: string) => {
    return markdown
        .replace(/^### (.*$)/gim, '<h3>$1</h3>')
        .replace(/^## (.*$)/gim, '<h2>$1</h2>')
        .replace(/^# (.*$)/gim, '<h1>$1</h1>')
        .replace(/\*\*(.*?)\*\*/gim, '<b>$1</b>')
        .replace(/\*(.*?)\*/gim, '<i>$1</i>')
        .replace(
            /\[([^\]]+)\]\(([^)]+)\)/gim,
            '<a href="$2" target="__blank">$1</a>'
        )
        .replace(/\n/g, '<br>');
};

export const sendDataLayer = (event: Object) => {
    window.ga_debug = { trace: true };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
};
